import React from 'react';
import PropTypes from 'prop-types';

const classStatus = (status) => {
  switch (status) {
    case 'CONF':
      return 'text-green-700';
    case 'CANC': /* falls through */
    case 'REVO':
      return 'text-status-red';
    case 'PEND': /* falls through */
    default:
      return 'text-status-gray';
  }
};

const BookingStatus = ({ status, statusDisplay }) => (
        <h1 className={`text-2xl uppercase font-bold ${classStatus(status)}`}>{statusDisplay}</h1>
);

BookingStatus.contextTypes = {
  t: PropTypes.func.isRequired,
};

BookingStatus.propTypes = {
  status: PropTypes.string,
  statusDisplay: PropTypes.string,
};

export default BookingStatus;
